import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import { Instagram, WhatsApp, Place } from '@mui/icons-material';

import { STORE, whatsappLink } from '../../config/store';

export const SOCIAL = [
    { label: `Instagram @${STORE.instagramHandle}`, href: STORE.instagramUrl, icon: Instagram },
    { label: `WhatsApp ${STORE.whatsappDisplay}`, href: whatsappLink('Hi Raano!'), icon: WhatsApp },
    { label: 'Store location on Google Maps', href: STORE.mapsUrl, icon: Place },
];

// Outlined circle icon links, used in the announcement bar and the footer
export const SocialCircles = ({ size = 24, color = 'raano.onDark' }) => (
    <Box display='flex' gap='8px' >
        {SOCIAL.map(({ label, href, icon: SocialIcon }) => (
            <Box
                key={href} as='a' href={href} target='_blank' rel='noreferrer' aria-label={label} title={label}
                width={`${size}px`} height={`${size}px`} borderRadius='full' border='1px solid' borderColor={color} color={color}
                display='flex' alignItems='center' justifyContent='center' transition='opacity .125s' _hover={{ opacity: 0.7 }}
            >
                <SocialIcon sx={{ fontSize: size * 0.58 }} />
            </Box>
        ))}
    </Box>
);

// Black 42px strip above the header, desktop only (design-system.md §3.1)
const AnnouncementBar = () => (
    <Box display={{ base: 'none', md: 'flex' }} alignItems='center' justifyContent='space-between' height='42px' px='40px' bg='raano.black' color='raano.onDark' >
        <Box display='flex' gap='16px' fontSize='14px' >
            <Text as='a' href={STORE.mapsUrl} target='_blank' rel='noreferrer' _hover={{ textDecoration: 'underline' }} >Find our store</Text>
            <Text as='a' href={whatsappLink('Hi Raano!')} target='_blank' rel='noreferrer' _hover={{ textDecoration: 'underline' }} >Contact</Text>
        </Box>
        <SocialCircles />
    </Box>
);

export default AnnouncementBar;
